module.exports = __webpack_public_path__ + "media/localization/spanish-0f8dff62.png";